export type KianEntityType =
  | 'cw-ticket'
  | 'weclapp-ticket'
  | 'submission'
  | 'infrastructure-host'
  | 'infrastructure-site'
  | 'trip'
  | 'inventory-session'
  | 'customer'
  | 'project'
  | 'new-ticket-draft'
  | 'general';

export interface KianEntityContext {
  type: KianEntityType | string;
  id: string;
  label: string;
  metadata?: Record<string, unknown>;
  visitedAt: number;
}

export interface KianPageContextValue {
  current: KianEntityContext | null;
  recent: KianEntityContext[];
  pinned: KianEntityContext[];
  register: (ctx: Omit<KianEntityContext, 'visitedAt'>) => void;
  unregister: () => void;
  pinEntity: (ctx: KianEntityContext) => void;
  unpinEntity: (entityKey: string) => void;
  clearPins: () => void;
  removeRecent: (entityKey: string) => void;
}

export function entityKey(e: Pick<KianEntityContext, 'type' | 'id'>): string {
  return `${e.type}:${e.id}`;
}
